import { Box, Chip, Stack, Typography, styled } from '@mui/material';

export const StyledOuterContainer = styled(Stack)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  background: theme.palette.grey[800],
  padding: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2),
  },
}));

export const StyledInnerContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 0,
  },
}));

export const CoverArt = styled('img')(({ theme }) => ({
  width: theme.spacing(20),
  height: theme.spacing(20),
  [theme.breakpoints.down('md')]: {
    width: '100%',
    height: 'auto',
    aspectRatio: '1 / 1',
    alignSelf: 'center',
  },
}));

export const ReleaseInfoContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  overflow: 'hidden',
}));

export const ReleaseBaseInfoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  marginTop: theme.spacing(1.5),
  padding: theme.spacing(0.5),
}));

export const SongTitle = styled(Typography)(({ theme }) => ({
  fontSize: 24,
  [theme.breakpoints.down('md')]: {
    fontSize: 20,
  },
  fontWeight: 900,
}));

export const ArtistName = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  [theme.breakpoints.down('md')]: {
    fontSize: 15,
  },
  color: theme.palette.grey[50],
  marginTop: theme.spacing(0.5),
}));

export const StyledChip = styled(Chip)({
  maxWidth: 'min-content',
});
StyledChip.defaultProps = {
  variant: 'outlined',
};
